import React, { createContext, useCallback, useContext, } from 'react';
import useSWR from 'swr';
import { fetchAb } from '@dev-togetherprice/api.services';
const fetchUserExperimentByName = (name) => fetchAb(`/user-experiments/${name}`);
const fetchAllUserExperiments = () => fetchAb('/user-experiments');
const AbTestContext = createContext({});
export const useAbTest = () => useContext(AbTestContext);
const createGenerateVariant = (data, handler) => (nameToLoad) => {
    const userExperiment = data === null || data === void 0 ? void 0 : data.find(({ name }) => name === nameToLoad);
    if (userExperiment)
        return Promise.resolve(userExperiment.variant);
    return handler(nameToLoad)
        .then((experiment) => experiment === null || experiment === void 0 ? void 0 : experiment.variant)
        .catch((e) => {
        console.error('error generating variant', e);
        return null;
    });
};
const AbTest = ({ children, preloadExperiments = fetchAllUserExperiments, loadExperimentByName = fetchUserExperimentByName, }) => {
    const { data = [] } = useSWR('preloadExperiments', () => preloadExperiments().catch((error) => {
        console.error(error);
        return [];
    }), {
        dedupingInterval: 1000 * 60 * 90,
        revalidateOnMount: true,
        suspense: true,
    });
    const generateVariant = useCallback(createGenerateVariant(data, loadExperimentByName), [data, loadExperimentByName]);
    return (React.createElement(AbTestContext.Provider, { value: {
            generateVariant,
        } }, children));
};
export default AbTest;
